<template>
  <div>
    <v-tabs
      v-model="currentOfficeTab"
      background-color="transparent"
      color="basil"
      grow
      show-arrows
    >
      <v-tab
        v-for="item in officeTabSetting"
        :key="item.id"
        :href="'#' + item.id"
        @click="onTabChange(item)"
      >
        {{ item.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentOfficeTab">
      <v-tab-item
        :value="tabData.OFFICE_COMMON_INFORMATION_TAB"
      >
        <v-card
          class="mx-auto"
          outlined
        >
          <v-alert
            v-if="hasDefaultAddress"
            outlined
            type="warning"
            border="left"
          >
            {{ defaultAddressAlertMessage }}
          </v-alert>
          <v-toolbar
            flat
            color="white"
            class="mx-0 px-0"
          >
            <v-subheader class="heading">
              Объект номер {{ getOffice ? getOffice.supportNumber : '' }}
            </v-subheader>
            <!--                  <v-toolbar-title>Общий</v-toolbar-title>-->
            <div>
              <v-btn
                color="success"
                text
              >
                {{ `Баланс:` }}
              </v-btn>

              <v-btn
                color="success"
                rounded
                outlined
              >
                {{ `${getTotalAmount} ₽` }}
              </v-btn>
            </div>
            <div>
              <v-btn
                color="secondary"
                text
              >
                {{ `Офферы:` }}
              </v-btn>

              <v-btn
                color="secondary"
                rounded
                outlined
              >
                {{ `${getTotalOffers}` }}
              </v-btn>
            </div>
            <v-spacer />
          </v-toolbar>

          <template>
            <v-expansion-panels
              v-if="getOffice && getOffice.id"
              v-model="selectedPanelList"
              multiple
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Общий
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-if="$route.params && $route.params.id !== 'new' && getOffice && getOffice.id">
                    <v-row
                      no-gutters
                      class="px-4"
                    >
                      <v-col
                        cols="3"
                        class="px-3 py-3"
                        :sm="6"
                        :md="3"
                      >
                        <v-checkbox
                          v-model="hasActiveWorkflow"
                          label="Активный"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="3"
                        class="px-3 py-3"
                        :sm="4"
                        :md="3"
                      >
                        <v-text-field
                          v-model="getOffice.supportNumber"
                          label="Номер"
                          outlined
                          disabled
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="3"
                        class="px-3 py-3"
                        :sm="6"
                        :md="3"
                      >
                        <v-text-field
                          v-model="getOffice.storeId"
                          label="Внешний номер API"
                          outlined
                          disabled
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-select
                          v-model="getOffice.shiftProviderLevel"
                          :disabled="!hasActiveWorkflow || !providerLevelSwitchable"
                          :items="shiftProviderLevelList"
                          label="Новый объект"
                          :item-text="'title'"
                          :item-value="'id'"
                          return-object
                          outlined
                          required
                          :hint="getLastOfferDate"
                          :persistent-hint="!!getLastOfferDate"
                          @change="onFieldChange"
                        />
                      </v-col>

                      <v-col
                        cols="12"
                        class="px-3 py-0 mt-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-select
                          v-model="getOffice.type"
                          outlined
                          :items="dictionaries.officeTypeList"
                          label="Тип"
                          :item-text="'title'"
                          :item-value="'id'"
                          return-object
                          required
                          @change="onFieldChange"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-0 mt-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-select
                          v-model="getOffice.industry"
                          outlined
                          :items="dictionaries.industryList"
                          label="Отрасль"
                          :item-text="'title'"
                          :item-value="'id'"
                          return-object
                          required
                          @change="onFieldChange"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-0 mt-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-autocomplete
                          v-model="getOffice.legalEntity"
                          :disabled="!getOffice.organization.hasAgencyContract || !officeContractEditable"
                          :items="legalEntityList"
                          return-object
                          item-value="id"
                          item-text="title"
                          label="Выберите Юр. лицо"
                          outlined
                          chips
                          small-chips
                          @change="onLegalEntityChange"
                        />
                      </v-col>
                      <v-col
                        v-if="hasLegalEntity"
                        cols="12"
                        class="px-3 py-0 mt-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-autocomplete
                          v-model="getOffice.contract"
                          :items="getOffice.legalEntity.contractList || []"
                          return-object
                          item-value="id"
                          item-text="title"
                          label="Выберите контракт"
                          outlined
                          chips
                          :disabled="!officeContractEditable"
                          small-chips
                        />
                        <!--                        <v-select-->
                        <!--                          v-model="getOffice.contract"-->
                        <!--                          :items="getOffice.legalEntity.contractList || []"-->
                        <!--                          label="контракт"-->
                        <!--                          :item-text="'title'"-->
                        <!--                          :item-value="'id'"-->
                        <!--                          return-object-->
                        <!--                          required-->
                        <!--                          outlined-->
                        <!--                        />-->
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-text-field
                          v-model="getOffice.externalCode"
                          label="Код завода"
                          required
                          outlined
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-text-field
                          v-model="getOffice.title"
                          label="Название"
                          required
                          outlined
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-select
                          v-model="getOffice.location.timeZone"
                          :items="sortedTimeZoneList"
                          label="часовой пояс (смещение от UTC)"
                          :item-text="'title'"
                          :item-value="'id'"
                          return-object
                          outlined
                          required
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-0 mt-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-select
                          v-model="getOffice.supervisor"
                          :items="supervisorList"
                          label="Менеджер"
                          :item-text="'title'"
                          :item-value="'id'"
                          return-object
                          required
                          outlined
                          @change="onFieldChange"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="px-3 py-0 mt-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-text-field
                          :value="getOffice.territory ? getOffice.territory.title : ''"
                          outlined
                          label="Территория"
                          required
                          disabled
                        />
                      </v-col>
                    </v-row>
                    <fieldset style="border: thin solid #80808042">
                      <v-alert
                        v-if="hasDefaultAddress"
                        outlined
                        type="warning"
                        border="left"
                      >
                        {{ defaultAddressAlertMessage }}
                      </v-alert>
                      <legend>Локализация</legend>
                      <v-row
                        no-gutters
                        class="px-4"
                      >
                        <v-col
                          cols="12"
                          class="px-3 py-3"
                          :sm="12"
                          :md="6"
                        >
                          <v-text-field
                            v-model="getOffice.address"
                            outlined
                            label="Адрес"
                            required
                            readonly
                            :append-outer-icon="'mdi-pencil'"
                            @click:append-outer="onEditOffice"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          class="px-3 py-3"
                          :sm="12"
                          :md="6"
                        >
                          <v-text-field
                            v-model="getCityLabel"
                            label="Населенный пункт"
                            required
                            disabled
                            outlined
                          />
                        </v-col>

                        <v-col
                          cols="12"
                          class="px-3 py-0 mt-3"
                          :sm="12"
                          :md="6"
                        >
                          <v-text-field
                            :value="getOffice.province ? getOffice.province.title: ''"
                            outlined
                            label="Округ"
                            required
                            disabled
                          />
                        </v-col>
                      </v-row>
                    </fieldset>
                    <fieldset style="border: thin solid #80808042">
                      <legend>Организация</legend>
                      <v-row
                        no-gutters
                        class="px-4"
                      >
                        <v-col
                          v-if="getOffice.organization"
                          cols="12"
                          class="px-3 py-3"
                          :sm="12"
                          :md="6"
                        >
                          <ItemLinkView
                            :label="undefined"
                            :value="getOrganizationViewHref(getOffice.organization)"
                            :link-text="`${getOffice.organization ? getOffice.organization.title : ''}`"
                          />
                        </v-col>
                      </v-row>
                    </fieldset>
                    <v-list three-line>
                      <v-subheader
                        v-text="'Менеджеры'"
                      />

                      <template v-for="(item, index) in getOffice.managerList">
                        <v-divider
                          :key="index"
                        />

                        <v-list-item
                          :key="item.id"
                        >
                          <v-list-item-avatar>
                            <v-img :src="avatar" />
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title v-text="item.fullName" />
                            <v-list-item-subtitle v-text="item.email" />
                            <v-list-item-subtitle v-text="item.telephone" />
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list>
                    <v-row
                      no-gutters
                      class="px-4"
                    >
                      <v-col
                        cols="3"
                        class="px-3 py-3"
                        :sm="12"
                        :md="6"
                      >
                        <v-card-actions>
                          <v-btn
                            text
                            outlined
                            rounded
                            color="success"
                            class="ml-6 my-4"
                            @click="saveOffice"
                          >
                            Сохранить
                          </v-btn>
                          <v-btn
                            v-if="!hasActiveWorkflow"
                            color="success"
                            text
                            @click="activeOffice(getOffice)"
                          >
                            Активировать объект
                          </v-btn>
                        </v-card-actions>
                      </v-col>
                      <v-col
                        cols="3"
                        class="px-3 py-3"
                        :sm="12"
                        :md="6"
                      >
                        <div class="ml-2">
                          <p
                            v-if="hasDefaultAddress"
                            class="py-0 my-0"
                          >
                            <span
                              class="text--warning"
                              style="color: orangered"
                            > - Объект создан с дефолтным адресом</span>
                          </p>

                          <p
                            v-for="(error, index) of activationErrorList"
                            :key="index"
                            class="py-0 my-0"
                            style="display: list-item"
                          >
                            <span
                              class="text--warning"
                              style="color: orangered"
                            > - {{ error }}</span>
                          </p>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Место встречи
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <MeetPointFrom
                    v-if="getOffice && getOffice.id"
                    :office="getOffice"
                    :metroStationList="metroStationList"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Как добраться
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <TransportationForm
                    v-if="getOffice && getOffice.id"
                    :office="getOffice"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-card>
      </v-tab-item>
      <v-tab-item
        :value="tabData.OFFICE_STAFF_INFORMATION_TAB"
      >
        <WBDOfficeStaffManager
          v-if="currentOfficeTab === tabData.OFFICE_STAFF_INFORMATION_TAB && getOffice && getOffice.id"
          :office="getOffice"
          @reloadOfficeView="requestModel($route.params.id)"
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.OFFICE_BLACK_LIST_INFORMATION_TAB"
      >
        <WBDBlackListManager
          v-if="getOffice && getOffice.id"
          :office="getOffice"
          show-add-btn
          @reloadOfficeView="requestModel($route.params.id)"
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.OFFICE_OFFER_STATEMENT_TAB"
      >
        <WBDStatementListPage
          v-if="currentOfficeTab === tabData.OFFICE_OFFER_STATEMENT_TAB && getOffice && getOffice.id"
          :office="getOffice"
          lite
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.OFFICE_MONEY_STATEMENT_TAB"
      >
        <WBDStatementListPage
          v-if="currentOfficeTab === tabData.OFFICE_MONEY_STATEMENT_TAB && getOffice && getOffice.id"
          :office="getOffice"
          :discr="'money_balance_logger'"
          lite
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.OFFICE_VACANCY_TAB"
      >
        <WBDBVacancyRateList
          v-if="currentOfficeTab === tabData.OFFICE_VACANCY_TAB && getOffice && getOffice.id"
          :office="getOffice"
          lite
        />
      </v-tab-item>
      <v-tab-item
        :value="tabData.OFFICE_OFFER_TAB"
      >
        <WBDOfferListPage
          v-if="currentOfficeTab === tabData.OFFICE_OFFER_TAB && getOffice && getOffice.id"
          :office="getOffice"
          lite
        />
      </v-tab-item>
    </v-tabs-items>
    <EditAddressFormDrawer
      ref="addressEditRef"
      style="visibility: hidden"
      :model="getOffice"
      @EditAddressSuccess="reload"
    />
  </div>
</template>

<script>

import MeetPointFrom from '@/views/office/meet-point-form.vue'
import TransportationForm from '@/views/office/transportation-form'
import OrganizationMixin from '@/mixins/organizationMixin.vue'
import DictionaryMixin from '@/mixins/dictionaryMixin'
// import WBDCitySelectorFilter from '@/components/common/filter/city-search-filter'
import WBDBlackListManager from '@/views/blackList/view'
import WBDOfficeStaffManager from '@/views/officeStaff/view'
import { formatDateTime } from '@/utils/dateUtl'
import WBDStatementListPage from '@/views/statement/list'
import WBDBVacancyRateList from '@/views/vacancy-region-rate/view'
import WBDOfferListPage from '@/views/offer/list'

const OFFICE_COMMON_INFORMATION_TAB = 'office-common-information'
const OFFICE_STAFF_INFORMATION_TAB = 'office-staff-information'
const OFFICE_BLACK_LIST_INFORMATION_TAB = 'office-black-list-information'
const OFFICE_OFFER_STATEMENT_TAB = 'office-offer-statement'
const OFFICE_MONEY_STATEMENT_TAB = 'office-money-statement'
const OFFICE_VACANCY_TAB = 'office-vacancy-list'
const OFFICE_OFFER_TAB = 'office-offer-list'

export const SHIFT_PROVIDER_LEVEL_STARTER = 'shift-starter-provider'
export const SHIFT_PROVIDER_LEVEL_CONFIRMED = 'shift-confirmed-provider'
import ApiMixin from '@/mixins/api-mixin'
import AppLogger from '@/utils/appLogger'
import EditAddressFormDrawer from '@/views/office/address/edit-address-form-drawer.vue'
import AppUserAccessManager from '@/utils/user-roles-util'

export default {
  name: 'WBDOfficeViewPage',
  components: {
    EditAddressFormDrawer,
    MeetPointFrom,
    TransportationForm,
    WBDBVacancyRateList,
    WBDOfferListPage,
    // WBDCitySelectorFilter,
    WBDBlackListManager,
    WBDStatementListPage,
    WBDOfficeStaffManager
  },
  mixins: [ApiMixin, OrganizationMixin, DictionaryMixin],
  data: () => ({
    selectedLegalEntity: null,
    activationErrorList: [],
    shiftProviderLevelList: [

      {
        'id': null, 'title': 'Нет',
      },
      {
        'id': SHIFT_PROVIDER_LEVEL_STARTER,
        'title': 'Да',
      }
    ],
    timeZoneList: [
      {
        'id': 'Europe/Astrakhan',
        'title': 'Europe/Astrakhan(+4)',
        'offset': 4
      },
      {
        'id': 'Asia/Almaty',
        'title': 'Asia/Almaty(+6)',
        'offset': 6
      },
      {
        'id': 'Asia/Anadyr',
        'title': 'Asia/Anadyr(+12)',
        'offset': 12
      },
      {
        'id': 'Asia/Novosibirsk',
        'title': 'Asia/Novosibirsk(+7)',
        'offset': 7
      },
      {
        'id': 'Europe/Saratov',
        'title': 'Europe/Saratov(+4)',
        'offset': 4
      },
      {
        'id': 'Asia/Tomsk',
        'title': 'Asia/Tomsk(+7)',
        'offset': 7
      },
      {
        'id': 'Europe/Moscow',
        'title': 'Europe/Moscow(+3)',
        'offset': 3
      },
      {
        'id': 'Asia/Baku',
        'title': 'Asia/Baku(+4)',
        'offset': 4
      },
      {
        'id': 'Europe/Oslo',
        'title': 'Europe/Oslo(+1)',
        'offset': 1
      },
      {
        'id': 'Europe/Tallinn',
        'title': 'Europe/Tallinn(+2)',
        'offset': 2
      },
      {
        'id': 'Asia/Vladivostok',
        'title': 'Asia/Vladivostok(+10)',
        'offset': 10
      },
      {
        'id': 'Asia/Aqtobe',
        'title': 'Asia/Aqtobe(+5)',
        'offset': 5
      },
      {
        'id': 'Asia/Krasnoyarsk',
        'title': 'Asia/Krasnoyarsk(+7)',
        'offset': 7
      },
      {
        'id': 'Europe/Samara',
        'title': 'Europe/Samara(+4)',
        'offset': 4
      },
      {
        'id': 'Europe/Minsk',
        'title': 'Europe/Minsk(+3)',
        'offset': 3
      },
      {
        'id': 'Asia/Hovd',
        'title': 'Asia/Hovd(+7)',
        'offset': 7
      },
      {
        'id': 'Asia/Magadan',
        'title': 'Asia/Magadan(+11)',
        'offset': 11
      },
      {
        'id': 'Europe/Warsaw',
        'title': 'Europe/Warsaw(+1)',
        'offset': 1
      },
      {
        'id': 'Asia/Barnaul',
        'title': 'Asia/Barnaul(+7)',
        'offset': 7
      },
      {
        'id': 'Asia/Choibalsan',
        'title': 'Asia/Choibalsan(+8)',
        'offset': 8
      },
      {
        'id': 'Europe/Ulyanovsk',
        'title': 'Europe/Ulyanovsk(+4)',
        'offset': 4
      },
      {
        'id': 'Asia/Sakhalin',
        'title': 'Asia/Sakhalin(+11)',
        'offset': 11
      },
      {
        'id': 'Europe/Riga',
        'title': 'Europe/Riga(+2)',
        'offset': 2
      },
      {
        'id': 'Asia/Tokyo',
        'title': 'Asia/Tokyo(+9)',
        'offset': 9
      },
      {
        'id': 'Europe/Kyiv',
        'title': 'Europe/Kyiv(+2)',
        'offset': 2
      },
      {
        'id': 'Asia/Chita',
        'title': 'Asia/Chita(+9)',
        'offset': 9
      },
      {
        'id': 'Asia/Oral',
        'title': 'Asia/Oral(+5)',
        'offset': 5
      },
      {
        'id': 'Europe/Kirov',
        'title': 'Europe/Kirov(+3)',
        'offset': 3
      },
      {
        'id': 'Europe/Kaliningrad',
        'title': 'Europe/Kaliningrad(+2)',
        'offset': 2
      },
      {
        'id': 'Asia/Omsk',
        'title': 'Asia/Omsk(+6)',
        'offset': 6
      },
      {
        'id': 'Europe/Volgograd',
        'title': 'Europe/Volgograd(+3)',
        'offset': 3
      },
      {
        'id': 'Europe/Simferopol',
        'title': 'Europe/Simferopol(+3)',
        'offset': 3
      },
      {
        'id': 'Asia/Qostanay',
        'title': 'Asia/Qostanay(+6)',
        'offset': 6
      },
      {
        'id': 'Asia/Shanghai',
        'title': 'Asia/Shanghai(+8)',
        'offset': 8
      },
      {
        'id': 'Europe/Helsinki',
        'title': 'Europe/Helsinki(+2)',
        'offset': 2
      },
      {
        'id': 'Asia/Kamchatka',
        'title': 'Asia/Kamchatka(+12)',
        'offset': 12
      },
      {
        'id': 'Asia/Irkutsk',
        'title': 'Asia/Irkutsk(+8)',
        'offset': 8
      },
      {
        'id': 'Asia/Yekaterinburg',
        'title': 'Asia/Yekaterinburg(+5)',
        'offset': 5
      },
      {
        'id': 'Asia/Ulaanbaatar',
        'title': 'Asia/Ulaanbaatar(+8)',
        'offset': 8
      },
      {
        'id': 'Asia/Yakutsk',
        'title': 'Asia/Yakutsk(+9)',
        'offset': 9
      },
      {
        'id': 'Europe/Vilnius',
        'title': 'Europe/Vilnius(+2)',
        'offset': 2
      },
      {
        'id': 'Asia/Novokuznetsk',
        'title': 'Asia/Novokuznetsk(+7)',
        'offset': 7
      }
    ],
    avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
    metroStationList: [],
    supervisorList: [],
    legalEntityList: [],
    regionList: [],
    dictionaries: { officeTypeList: [], industryList: [] },
    selectedPanelList: [0],
    hasRequestedLegalEntityList: false,
    currentOfficeTab: null,
    tabData: {
      OFFICE_COMMON_INFORMATION_TAB,
      OFFICE_STAFF_INFORMATION_TAB,
      OFFICE_BLACK_LIST_INFORMATION_TAB,
      OFFICE_OFFER_STATEMENT_TAB,
      OFFICE_MONEY_STATEMENT_TAB,
      OFFICE_VACANCY_TAB,
      OFFICE_OFFER_TAB,
    },
    officeTabSetting: [
      // { title: 'Общая информация', id: OFFICE_COMMON_INFORMATION_TAB },
      // { title: 'Офферы', id: OFFICE_OFFER_TAB },
      // { title: 'Вакансии', id: OFFICE_VACANCY_TAB },
      // { title: 'Списание офферов', id: OFFICE_OFFER_STATEMENT_TAB },
      // { title: 'Моя команда', id: OFFICE_STAFF_INFORMATION_TAB },
      // { title: 'Черный список', id: OFFICE_BLACK_LIST_INFORMATION_TAB },
    ],
  }),
  computed: {
    defaultAddressAlertMessage () {
      return 'Объект создан с дефолтным адресом! Не получилось определить адрес объекта при импорте. ' +
          '                        Требуется изменить адрес до того как активировать объект'
    },
    hasDefaultAddress () {
      if (!this.getOffice) {
        return false
      }
      return !this.getOffice.isActive && !!this.getOffice.isAutoCreated
    },
    getTotalAmount () {
      if (!this.getOffice || !this.getOffice.amount) {
        return 0
      }

      return new Intl.NumberFormat().format(this.getOffice.amount)
    },
    getTotalOffers () {
      if (!this.getOffice || !this.getOffice.availableOffersNumber) {
        return 0
      }

      return this.getOffice.availableOffersNumber
    },
    hasActiveWorkflow () {
      return this.getOffice.status === 'active'
    },
    providerLevelSwitchable () {
      const { isConfirmedProvider, providerLevelSwitchable } = this.getOffice
      if (!isConfirmedProvider || !this.getLastOfferData) {
        return true
      }

      return !!providerLevelSwitchable
    },
    getLastOfferData () {
      if (!this.getOffice || !this.getOffice.lastOfferData || !this.getOffice.lastOfferData.id) {
        return null
      }

      return this.getOffice.lastOfferData
    },
    getLastOfferDate () {
      const lastOffer = this.getLastOfferData
      if (!lastOffer) {
        return null
      }
      const { isConfirmedProvider, providerLevelSwitchable } = this.getOffice

      const days = lastOffer.days
      const dayText = days ? `(${days} Д. назад)` : ''
      const message = !!isConfirmedProvider && !providerLevelSwitchable
        ? 'Статус новый можно поставить только объекту который делал последнюю заявку более 60 дней назад' : ''
      return `Пос. оффер ${formatDateTime(lastOffer.createdAt)} ${dayText}. ${message}`
    },
    getCityLabel () {
      if (!this.getOffice || !this.getOffice.city) {
        return null
      }
      return this.getOffice.city.title
    },
    getCitySelectedOptionValue () {
      if (!this.getOffice || !this.getOffice.city || !this.getOffice.city.id) {
        return ''
      }

      return this.getOffice.city || ''
    },
    sortedTimeZoneList () {
      const self = this
      return self.timeZoneList.sort((a, b) => {
        if (a.offset > b.offset) {
          return 1
        }
        if (a.offset < b.offset) {
          return -1
        }
        return 0
      })
    },
    canActive () {
      const { region, organization, city, legalEntity, contract, supervisor, industry } = this.getOffice

      const hasRegion = region && region.id
      const hasSupervisor = supervisor && supervisor.id
      const hasCity = city && city.id
      const hasIndustry = industry && industry.id
      // const hasActiveStatus = status === 'active'
      const hasOrganization = organization && organization.id
      let hasActiveOrganization = hasOrganization && organization.status === 'active'
      let hasLegalEntity = true
      let hasContract = true

      if (hasOrganization) {
        hasActiveOrganization = organization.hasAgencyContract === true
        hasLegalEntity = legalEntity && legalEntity.id
        hasContract = contract && contract.id
      }

      return hasRegion && hasCity && hasActiveOrganization && hasLegalEntity &&
          hasContract && hasSupervisor && hasIndustry
    },
    hasLegalEntity () {
      return !!this.selectedLegalEntity && !!this.selectedLegalEntity.id
    },
    hasActiveStatus () {
      return !!this.getOffice && this.getOffice.status === 'active'
    },
    officeContractEditable () {
      if (!this.hasActiveStatus) {
        return true
      }
      return AppUserAccessManager.hasOfficeContractManagerRole(this.getLoggedUser)
    },
    getOffice () {
      const self = this
      const office = this.$store.getters['office/getStoreModel'](
        this.$route.params.id,
      )
      if (office) {
        if (!this.legalEntityList.length &&
            !this.hasRequestedLegalEntityList && office.organization.hasAgencyContract) {
          this.loadLegalEntityList(office.organization.id)
        }
        if (!!office.legalEntity && !!office.legalEntity.id) {
          self.selectedLegalEntity = office.legalEntity
        }


        const draftOfficeTabList = [
          { title: 'Общая информация', id: OFFICE_COMMON_INFORMATION_TAB },
          { title: 'Вакансии', id: OFFICE_VACANCY_TAB },
        ]
        const activeOfficeTabList = [
          { title: 'Общая информация', id: OFFICE_COMMON_INFORMATION_TAB },
          { title: 'Офферы', id: OFFICE_OFFER_TAB },
          { title: 'Вакансии', id: OFFICE_VACANCY_TAB },
          { title: 'Списание офферов', id: OFFICE_OFFER_STATEMENT_TAB },
          { title: 'Списание ДС', id: OFFICE_MONEY_STATEMENT_TAB },
          { title: 'Моя команда', id: OFFICE_STAFF_INFORMATION_TAB },
          { title: 'Черный список', id: OFFICE_BLACK_LIST_INFORMATION_TAB },
        ]

        if (office.status !== 'active') {
          self.officeTabSetting = draftOfficeTabList
        } else {
          self.officeTabSetting = activeOfficeTabList
        }

        return {
          ...office
        }
      }
      return null
    },
  },
  watch: {
    getOffice: {
      handler (val) {
        this.$nextTick(() => {
          this.checkActivation()
        })
      },
      deep: true,
    },
  },
  async created () {
    this.currentOfficeTab = this.tabData.OFFICE_COMMON_INFORMATION_TAB
    await this.getMetroStation()
    await this.getManagerList()
    await this.loadDictionaries()
    await this.requestModel(this.$route.params.id)
    this.currentBaHandler()
  },
  methods: {
    checkActivation () {
      this.activationErrorList = []
      const errorList = {

      }
      const {
        region,
        organization,
        city,
        legalEntity,
        contract,
        supervisor,
        industry,
        location: { timeZone }
      } = this.getOffice

      const hasRegion = region && region.id
      const hasSupervisor = supervisor && supervisor.id
      const hasCity = city && city.id
      const hasIndustry = industry && industry.id
      // const hasActiveStatus = status === 'active'
      const hasOrganization = organization && organization.id
      const hasActiveOrganization = hasOrganization && !!organization.isActive
      let hasLegalEntity = true
      let hasContract = true
      const hasTimezone = !!timeZone && !!timeZone.id
      const hasAgencyContract = organization.hasAgencyContract === true

      if (hasAgencyContract) {
        hasLegalEntity = legalEntity && legalEntity.id
        hasContract = contract && contract.id
      }

      const isActive = hasRegion && hasCity && hasActiveOrganization && hasLegalEntity &&
          hasContract && hasSupervisor && hasIndustry && hasTimezone
      if (!isActive) {
        if (!hasRegion) {
          errorList.region = {
            isValid: hasRegion,
            message: 'Регион не заполнен',
          }
          this.activationErrorList.push(errorList.region.message)
        }
        if (!hasSupervisor) {
          errorList.hasSupervisor = {
            isValid: hasSupervisor,
            message: 'Менеджер не заполнен',
          }
          this.activationErrorList.push(errorList.hasSupervisor.message)
        }
        if (!hasCity) {
          errorList.city = {
            isValid: hasCity,
            message: 'Город не заполнен',
          }
          this.activationErrorList.push(errorList.city.message)
        }
        if (!hasIndustry) {
          errorList.hasIndustry = {
            isValid: hasIndustry,
            message: 'отрасль не заполнена',
          }
          this.activationErrorList.push(errorList.hasIndustry.message)
        }
        if (!hasActiveOrganization) {
          errorList.organization = {
            isValid: hasActiveOrganization,
            message: 'Организация не активная',
          }
          this.activationErrorList.push(errorList.organization.message)
        }
        if (!hasLegalEntity) {
          errorList.legalEntity = {
            isValid: hasLegalEntity,
            message: 'Юр. лицо не заполнено',
          }
          this.activationErrorList.push(errorList.legalEntity.message)
        }
        if (!hasContract) {
          errorList.contract = {
            isValid: hasContract,
            message: 'Контракт не заполнен',
          }
          this.activationErrorList.push(errorList.contract.message)
        }

        AppLogger.info(timeZone, 'timeZone')
        if (!timeZone || !timeZone.id) {
          errorList.timeZone = {
            isValid: hasTimezone,
            message: 'Часовой пояс не заполнен',
          }
          this.activationErrorList.push(errorList.timeZone.message)
        }
      }
      return isActive
    },
    async loadLegalEntityList (organizationId) {
      if (organizationId) {
        const list = await this.$store.dispatch(
          'organization/getLegalEntityList',
          {
            params: {
              'organization[id]': organizationId
            }
          })
        this.hasRequestedLegalEntityList = true
        this.legalEntityList = list.data.map((item) => ({
          ...item,
          title: `${item.title}, ${item.externalId}`
        }))
      }
    },
    async getManagerList () {
      const supervisorList = await this.$store.dispatch(
        'user/getManagerList',
        {
          params: {}
        })
      this.supervisorList = supervisorList.data.map((item) => ({
        ...item,
        title: `${item.fullName} / ${item.username}`
      }))
    },
    async getMetroStation () {
      const list = await this.$store.dispatch('organization/getMetroStationList')

      this.metroStationList = list.data
    },
    onLegalEntityChange (data) {
      this.selectedLegalEntity = data
      this.checkActivation()
    },
    onFieldChange () {
      this.checkActivation()
    },
    async requestModel (id) {
      await this.$store.dispatch('office/getModel', { id })
    },
    async saveOffice () {
      this.activationErrorList = []

      const {
        id,
        type,
        region,
        rawRegion,
        address,
        title,
        legalEntity,
        contract,
        externalCode,
        city,
        location,
        industry,
        shiftProviderLevel,
        supervisor
      } = this.getOffice
      const model = { id, region, address, title, externalCode }
      model.contract = null
      if (legalEntity && legalEntity.id) {
        model.legalEntity = legalEntity
      }
      if (industry && industry.id) {
        model.industry = { id: industry.id }
      }
      if (shiftProviderLevel && shiftProviderLevel.title) {
        model.shiftProviderLevel = shiftProviderLevel.id
      }

      if (city && city.id) {
        model.city = { id: city.id }
      }
      if (rawRegion && rawRegion.id) {
        model.region = { id: rawRegion.id }
      }
      if (supervisor && supervisor.id) {
        model.supervisor = { id: supervisor.id }
      }
      if (type && type.id) {
        model.type = { id: type.id }
      }

      if (contract && contract.id) {
        model.contract = { id: contract.id }
      }
      if (location && location.timeZone) {
        if (typeof location.timeZone === 'string') {
          model.timeZone = location.timeZone
        }

        if (typeof location.timeZone === 'object') {
          model.timeOffset = location.timeZone.offset
          model.timeZone = location.timeZone.id
        }
      }

      this.showPageLoader()
      this.$store.dispatch(
        `organization/editOffice`,
        model
      ).then((response) => {
        // window.location.reload()
        this.hidePageLoader()
      }).catch(() => {
        this.hidePageLoader()
      })
    },
    async loadDictionaries () {
      Promise.all([
        this.getDictionaries(
          'DICTIONARY_PATH',
          { params: { 'discr': 'office_type' } }
        ),
        this.getDictionaries(
          'DICTIONARY_PATH',
          { params: { 'discr': 'retail_industry' } }
        )
      ]).then((values) => {
        this.dictionaries.officeTypeList = values[0]
        this.dictionaries.industryList = values[1]
      })

      await this.requestRegionList(this.setRegionList, { showRaw: '1' })
    },
    setRegionList (regionListData) {
      if (regionListData && regionListData.error) {

      } else {
        this.regionList = regionListData.modelList
      }
    },
    onCitySelectorFilterChange (id) {
      if (id) {
        this.getOffice.city = { id }
      } else {
        this.getOffice.city = null
      }
    },
    onTabChange (data) {
      this.updateRouteData(data.id)
    },
    async updateRouteData (activeTab) {
      this.$router.replace({
        ...this.$router.currentRoute,
        query: { current_tab: activeTab }

      })
    },
    currentBaHandler () {
      const routeQuery = this.$route.query

      if (!routeQuery) {
        return
      }
      const queryTab = routeQuery.current_tab
      this.currentOfficeTab = queryTab || this.tabData.OFFICE_COMMON_INFORMATION_TAB
    },
    onEditOffice () {
      this.$refs.addressEditRef.enableModal()
    },
    reload () {
      this.requestModel(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" scoped>
    .office-item {
        cursor: pointer;
    }
</style>
